<template>
    <span>
        <span v-if="href" class="breadcrumb-item">
            <a :href="href" class="text-muted">
                <slot/>
            </a>
        </span>
        <span v-else class="breadcrumb-item active">
            <slot/>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        href: String,
    },
}
</script>
